// import React, { useEffect } from "react";
// import { Layout, Row, Col, Card, Avatar, Form, Button, Input } from "antd";
// import { UserOutlined } from "@ant-design/icons";

// const { Content } = Layout;

// const MyAccount = () => {
//   const [form] = Form.useForm();
//   useEffect(() => {
//     document.title = `MyAccount`;
//   }, []);
//   const onFinish = (values) => {
//     console.log(values);
//   };
//   return (
//     <Layout>
//       <Content style={{ padding: "50px" }}>
//         <Row gutter={16}>
//           <Col xs={24} sm={24} md={8} lg={6}>
//             <Card
//               bordered={false}
//               className="d-flex flex-column align-items-center"
//               style={{
//                 textAlign: "center",
//                 boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
//               }}
//             >
//               <Avatar
//                 className="d-flex"
//                 size={100}
//                 icon={<UserOutlined />}
//                 style={{ marginBottom: "20px" }}
//               />
//               <h2>Admin</h2>
//               <p>admin@gmail.com</p>
//               <p>7598474047</p>
//             </Card>
//           </Col>

//           <Col xs={24} sm={24} md={16} lg={18}>
//             <Card
//               title={<h5>Change Password</h5>}
//               style={{
//                 width: "100%",
//                 maxWidth: 1200,
//                 margin: "0 auto",
//                 padding: 20,
//                 boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
//                 borderRadius: 10,
//                 height: "auto",
//               }}
//             >
//               <Form
//                 form={form}
//                 name="change_password"
//                 onFinish={onFinish}
//                 layout="vertical"
//               >
//                 <Form.Item
//                   name="currentPassword"
//                   label="Current Password"
//                   rules={[
//                     {
//                       required: true,
//                       message: "Please input your current password!",
//                     },
//                   ]}
//                 >
//                   <Input.Password />
//                 </Form.Item>

//                 <Form.Item
//                   name="newPassword"
//                   label="New Password"
//                   rules={[
//                     {
//                       required: true,
//                       message: "Please input your new password!",
//                     },
//                   ]}
//                 >
//                   <Input.Password />
//                 </Form.Item>

//                 <Form.Item
//                   name="confirmPassword"
//                   label="Confirm Password"
//                   dependencies={["newPassword"]}
//                   rules={[
//                     {
//                       required: true,
//                       message: "Please confirm your new password!",
//                     },
//                     ({ getFieldValue }) => ({
//                       validator(_, value) {
//                         if (!value || getFieldValue("newPassword") === value) {
//                           return Promise.resolve();
//                         }
//                         return Promise.reject(
//                           new Error("The two passwords do not match!")
//                         );
//                       },
//                     }),
//                   ]}
//                 >
//                   <Input.Password />
//                 </Form.Item>

//                 <Form.Item>
//                   <Button
//                     type="primary"
//                     htmlType="submit"
//                     style={{ background: "#179bd7", border: "none" }}
//                   >
//                     Submit
//                   </Button>
//                 </Form.Item>
//               </Form>
//             </Card>
//           </Col>
//         </Row>
//       </Content>
//     </Layout>
//   );
// };

// export default MyAccount;

import React, { useState } from "react";
import { Form, Input, Button, Upload, Row, Col, Card, Avatar, Spin } from "antd";
import { UploadOutlined, UserOutlined, LockOutlined, PhoneOutlined, MailOutlined } from "@ant-design/icons";
import { getupdateprofiledata } from "../../Action/Actions";
import { getUserData } from "../login/LoginSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { message } from "antd";
import { updateProfile } from "../../Action/Actions";
import { useNavigate } from "react-router-dom";


const ProfileForm = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const AuthData = useSelector(getUserData);
  const [profileImage, setProfileImage] = useState("https://admin.vibeins.com/assets/img/default_profile_logo.png");
  const [profileData, setProfileData] = useState({});
  const [loading, setLoading] = useState(false);
  const userId = AuthData?.user_id;
  const handleImageChange = (info) => {
    if (info.file.status === "done") {
      setProfileImage(URL.createObjectURL(info.file.originFileObj));
    }
  };

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const data = await dispatch(getupdateprofiledata(userId));
        if (data?.ProfileData) {
          setProfileData(data.ProfileData); 
          form.setFieldsValue({
            full_name: data.ProfileData.full_name || "",
            username: data.ProfileData.corporate_username || "",
            email_id: data.ProfileData.email_address || "",
            mobile_no: data.ProfileData.mobile_no || "",
            department_name: data.ProfileData.department_name || "",
          });
        } else {
          message.error("Failed to fetch profile data.");
        }
      } catch (error) {
        console.error("Error fetching profile data:", error);
        message.error(error || "Error fetching profile data.");
      }
    };

    fetchProfileData();
  }, [dispatch, form, userId]);

  useEffect(() => {
    if (AuthData?.corporate_logo?.logofile) {
      setProfileImage(AuthData.corporate_logo.logofile);
    }
  }, [AuthData]);
  
  const handleSubmit = async (values) => {
    const profileData = {
      fullname: values.full_name,
      username: values.username,
      password: values.password , 
      email_address: values.email_id,
      mobile_no: values.mobile_no,
    };
  
    try {
      const response = await dispatch(updateProfile(userId, profileData, AuthData?.token));
      console.log(response.message || "Profile updated successfully!");
      message.success(response.message  );
    } catch (error) {
      console.log(error.message || "Profile update failed.");
      message.error(error.message );
    }
  };

  return (
    <Spin spinning={loading}>
    <Form form={form} onFinish={handleSubmit} layout="vertical" encType="multipart/form-data">
      <Row gutter={16} className="mt-5">
     {/* Profile Image and Overview */}
     <Col xs={24} sm={24} md={8} lg={6}>
  <Card
    bordered={false}
    className="d-flex flex-column align-items-center"
    style={{
      textAlign: "center",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      padding: "20px",
    }}
  >
    {/* Profile Image */}
    <Avatar
      size={100}
      src={profileImage}
      icon={<UserOutlined />}
      style={{ marginBottom: "16px" }}
    />

    {/* Upload Button */}
    {/* <Upload
      name="profile_logo"
      showUploadList={false}
      beforeUpload={() => false}
      onChange={handleImageChange}
      accept="image/*"
    >
      <Button
        icon={<UploadOutlined />}
        className="profile-edit"
        style={{
          marginBottom: "16px",
          backgroundColor: "#1890ff",
          color: "#fff",
          border: "none",
        }}
      >
        Upload
      </Button>
    </Upload> */}

    {/* User Details */}
    <div style={{ textAlign: "left", width: "100%" }}>
      <h5 className="main-profile-name" style={{ fontWeight: "bold", marginBottom: "8px" }}>
      {profileData.full_name}
      </h5>
      <p className="main-profile-name-text" style={{ color: "#888", marginBottom: "16px" }}>
      {profileData.department_name || "N/A"} 
      </p>
      <div className="main-profile-contact-list">
        <div className="media" style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
          <div
            className="media-icon bg-primary-transparent text-primary"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              marginRight: "12px",
              backgroundColor: "#e6f7ff",
              color: "#1890ff",
            }}
          >
            <LockOutlined />
          </div>
          <div className="media-body" style={{ textAlign: "left" }}>
            <span style={{ fontWeight: "bold", display: "block" }}>User Name</span>
            <div> {profileData.corporate_username}</div>
          </div>
        </div>
        <div className="media" style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
          <div
            className="media-icon bg-primary-transparent text-primary"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              marginRight: "12px",
              backgroundColor: "#e6f7ff",
              color: "#1890ff",
            }}
          >
            <PhoneOutlined />
          </div>
          <div className="media-body" style={{ textAlign: "left" }}>
            <span style={{ fontWeight: "bold", display: "block" }}>Mobile</span>
            <div>{profileData.mobile_no}</div>
          </div>
        </div>
        <div className="media" style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
          <div
            className="media-icon bg-success-transparent text-success"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              marginRight: "12px",
              backgroundColor: "#e6f7ff",
              color: "#1890ff",
            }}
          >
            <MailOutlined />
          </div>
          <div className="media-body" style={{ textAlign: "left" }}>
            <span style={{ fontWeight: "bold", display: "block" }}>Email ID</span>
            <div>{profileData.email_address}</div>
          </div>
        </div>
      </div>
    </div>
  </Card>
</Col>
        {/* Personal Information Form */}
        <Col xs={24} sm={24} md={16} lg={18}>
          <Card
            title={<h5>Personal Information</h5>}
            style={{
              width: "100%",
              maxWidth: 1200,
              margin: "0 auto",
              padding: 20,
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              borderRadius: 10,
              height: "auto",
            }}
          >
            <div className="mb-4 main-content-label">Personal Information</div>
            <Form.Item>
              <Row gutter={16}>
                <Col span={6}>
                  <label className="form-label">Full Name</label>
                </Col>
                <Col span={18}>
                  <Form.Item
                    name="full_name"
                   
                    rules={[
                      { required: true, message: "Please enter your full name" },
                      { pattern: /^[a-zA-Z ]+$/, message: "Full name can only contain letters and spaces" },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={6}>
                  <label className="form-label">User Name</label>
                </Col>
                <Col span={18}>
                  <Form.Item
                    name="username"
                   
                    rules={[{ required: true, message: "Please enter your username" }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={6}>
                  <label className="form-label">Password</label>
                </Col>
                <Col span={18}>
                  <Form.Item
                    name="password"
                    rules={[{ required: true, message: "Please enter your password" }]}
                  >
                    <Input.Password />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={6}>
                  <label className="form-label">Confirm Password</label>
                </Col>
                <Col span={18}>
                  <Form.Item
                    name="password"
                    dependencies={["password"]}
                    rules={[
                      { required: true, message: "Please confirm your password" },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue("password") === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error("The two passwords do not match!"));
                        },
                      }),
                    ]}
                  >
                    <Input.Password />
                  </Form.Item>
                </Col>
              </Row>
            </Form.Item>

            <div className="mb-4 main-content-label">Contact Info</div>
            <Form.Item>
              <Row gutter={16}>
                <Col span={6}>
                  <label className="form-label">Email</label>
                </Col>
                <Col span={18}>
                  <Form.Item
                    name="email_id"
                    
                    rules={[{ required: true, type: "email", message: "Please enter a valid email" }]}
                  >
                    <Input readOnly />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={6}>
                  <label className="form-label">Mobile No</label>
                </Col>
                <Col span={18}>
                  <Form.Item
                    name="mobile_no"
                  
                    rules={[
                      { required: true, message: "Please enter your mobile number" },
                      { pattern: /^[0-9]{10}$/, message: "Mobile number must be 10 digits" },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" style={{ background: "#179bd7", border: "none" }}>
                Update Profile
              </Button>
            </Form.Item>
          </Card>
        </Col>
      </Row>
    </Form>
    </Spin>
  );
};

export default ProfileForm;


